module.exports = __webpack_public_path__ + "assets/52f5e41546831202e68962fa30c8ef77.mp3";


/*****************
 ** WEBPACK FOOTER
 ** C:/Users/timice/Desktop/ROC2/engine/public-src/spingames/panel/sounds/buttons/max.mp3
 ** module id = 26
 ** module chunks = 0
 **/